import BlockRounded from "@mui/icons-material/BlockRounded";
import CreditCardRounded from "@mui/icons-material/CreditCardRounded";
import FamilyRestroomRounded from "@mui/icons-material/FamilyRestroomRounded";
import GroupRounded from "@mui/icons-material/GroupRounded";
import LockRounded from "@mui/icons-material/LockRounded";
import NotificationsRounded from "@mui/icons-material/NotificationsRounded";
import ReceiptLongRounded from "@mui/icons-material/ReceiptLongRounded";
import ShieldRounded from "@mui/icons-material/ShieldRounded";
import TuneRounded from "@mui/icons-material/TuneRounded";
import { Button, Stack } from "@mui/material";
import { useAuth } from "@bw/shared/hooks";
import { Page } from "../../../common/components/Page";
import { useMyProfile } from "../../../common/query/useMyProfile";
import { MeSectionNavigation } from "../components/MeSectionNavigation";
import { MeDestinationList } from "../components/MeDestinationList";
import type { MeAccountPageProps } from "../types";

const payments = [
  { label: "Saved cards", to: "/me/payments", icon: <CreditCardRounded /> },
  { label: "Transactions", to: "/me/transactions", icon: <ReceiptLongRounded /> },
];

export function MeAccountPage({ coachingExperienceLink, businessWorkspaceLink }: MeAccountPageProps) {
  const { signOut } = useAuth();
  const profile = useMyProfile();
  const visibility = profile.data?.visibility;
  const access = [
    { label: "Friends", to: "/me/friends", icon: <GroupRounded /> },
    { label: "Notifications & text messages", to: "/me/notifications", icon: <NotificationsRounded /> },
    {
      label: "Privacy & data",
      to: "/me/privacy",
      icon: <LockRounded />,
      value: visibility === "public" ? "Public profile" : visibility === "private" ? "Private profile" : undefined,
    },
    { label: "Safety & appeals", to: "/me/moderation", icon: <ShieldRounded /> },
    { label: "Blocked players", to: "/me/safety/blocked", icon: <BlockRounded /> },
    { label: "Family approvals", to: "/me/family/approvals", icon: <FamilyRestroomRounded /> },
  ];
  return (
    <Page title="Account" hideTitle narrow>
      <Stack spacing={2.5}>
        <MeSectionNavigation active="account" />
        <MeDestinationList title="Payments" items={payments} />
        <MeDestinationList title="Privacy, safety & family" items={access} />
        <MeDestinationList
          title="App"
          items={[{ label: "Display preferences", to: "/me/preferences", icon: <TuneRounded /> }]}
        >
          {businessWorkspaceLink}
          {coachingExperienceLink}
        </MeDestinationList>
        <Button
          onClick={() => void signOut()}
          variant="outlined"
          color="inherit"
          sx={{ borderRadius: 999 }}
        >
          Sign out
        </Button>
      </Stack>
    </Page>
  );
}
